module.exports = __webpack_public_path__ + "media/images/icon_images-f401c1c0a077d194973bbb66de86b7f7.png";